import mainWarp from '../components/main/main-wrap'
import stampWarp from '../components/mypage/stamp-wrap'
import tradeWrap from '../components/store/trade-wrap'
import matchWrap from '../components/match/match-wrap'
import roulette from '../components/event/roulette'
import cheer from '../components/event/cheer'
import partner from '../components/partner/partner'

// Routes
const routes = [
  {
    name: 'main',
    description: '뱃블 메인',
    path: '/',
    meta: {
      loc: 'main'
    },
    component: mainWarp
  },
  {
    name: 'stamp',
    description: 'stamp 리스트',
    path: '/mypage/stamp.php',
    meta: {
      loc: 'stamp'
    },
    component: stampWarp
  },
  {
    name: 'trade',
    description: 'trade 리스트',
    path: '/store/trade.php',
    meta: {
      loc: 'stamp'
    },
    component: tradeWrap
  },
  {
    name: 'match',
    description: 'match 리스트',
    path: '/match',
    meta: {
      loc: 'match'
    },
    component: matchWrap,
    children: [
      {
        name: 'matchIndex',
        path: '/match/index.php',
        component: matchWrap,
      }
    ]
  },
  {
    name: 'roulette',
    description: 'match 리스트',
    path: '/event/roulette.php',
    meta: {
      loc: 'roulette'
    },
    component: roulette
  },
  {
    name: 'cheer',
    description: '응원하기 페이지',
    path: '/event/cheer.php',
    meta: {
      loc: 'cheer'
    },
    component: cheer
  },
  {
    name: 'partner',
    description: '파트너',
    path: '/partner/statistics.php',
    component: partner
  }
];

export default routes




// WEBPACK FOOTER //
// ./src/router/routes.js